// extracted by mini-css-extract-plugin
module.exports = {"clients":"Clients_clients__1Blz9","title":"Clients_title__T6UtS","contentContainer":"Clients_contentContainer__0SG9u"};